import React from 'react';

import Badge from 'CommonComponents/Badge';

/**
 * The one place a week status becomes words and a colour, so the week card, the
 * calendar and the time summary cannot disagree. The status itself always comes
 * from the server.
 */
const STATUSES = {
    submitted: { variant: 'success', label: () => $t('Submitted') },
    draft: { variant: 'info', label: () => $t('Draft') },
    empty: { variant: 'neutral', label: () => $t('Nothing recorded') },
    future: { variant: 'neutral', label: () => $t('Not yet open') },
};

export function weekStatusLabel(status) {
    return (STATUSES[status] ?? STATUSES.empty).label();
}

export default function TimeWeekStatusPill({ status, size = 'md', className }) {
    const definition = STATUSES[status] ?? STATUSES.empty;

    return (
        <Badge variant={definition.variant} size={size} className={className}>
            {definition.label()}
        </Badge>
    );
}
